import { render, staticRenderFns } from "./revenueexample.vue?vue&type=template&id=785b4f1c&"
import script from "./revenueexample.vue?vue&type=script&lang=js&"
export * from "./revenueexample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports